<block-ui>
    <div class="row">
        <button class="form-control form-control-sm btn-light shadow-sm btn-st " style="width: 15%" (click)="RaiseCompanyModal(-1, content, false)">
                <i aria-hidden="true" class="fa fa-plus cursor-hand"></i> Agregar</button>
    </div>
    <div class="row mb-2"></div>
    <div class="row mt-2 tableFixHead">
        <table class="table table-striped table-sm table-hover">
            <thead>
                <tr>
                    <th scope="col">#</th>
                    <th scope="col">Nombre</th>
                    <th scope="col" class="text-center">Activa</th>
                    <th scope="col" class="text-center"></th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let record of companies" class="p-0">
                    <td>{{record.Id}}</td>
                    <td>{{record.Name}}</td>
                    <td class="text-center"><i class="fa fa-{{record.Active ? 'check': 'times'}}"></i></td>
                    <td class="justify-content-center option">
                        <i class="fa fa-edit" style="cursor: pointer;" title="Editar compañía" (click)="RaiseCompanyModal(record.Id, content, true)"></i>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

    <!-- MODAL PAR ACREACION EDICION DE COMPANIAS -->
    <ng-template #content let-modal>
        <div class="modal-header">
            <h5 class="modal-title">{{isOnEditMode ? 'Editar compañía':'Agregar compañía'}}</h5>
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                    <span aria-hidden="true">&times;</span>
                </button>
        </div>
        <div class="modal-body">
            <form [formGroup]="companyForm">
                <input type="number" style="display: none;" class="form-control form-control-sm" formControlName="Id">
                <div class="form-group">
                    <label for="">Nombre compañía</label>
                    <input type="email" class="form-control form-control-sm" formControlName="Name">
                </div>
                <div class="form-group">
                    <label for="">Identificador de compañía</label>
                    <input type="number" readonly class="form-control form-control-sm" formControlName="Id">
                </div>
                <div class="form-check">
                    <input type="checkbox" class="form-check-input" formControlName="Active" style="transform: scale(1.5); cursor: pointer">
                    <label class="form-check-label" for="exampleCheck1">Activo</label>
                </div>
                <div class="form-check mt-3">
                    <input type="checkbox" class="form-check-input" formControlName="UseRemoteService" style="transform: scale(1.5); cursor: pointer">
                    <label class="form-check-label">Utiliza servicio para generación de reportes</label>
                </div>
                <div class="form-group mt-3">
                    <label for="">URL del servicio remoto</label>
                    <input type="text" class="form-control form-control-sm" formControlName="RemoteServiceUrl">
                </div>
                <div class="form-group">
                    <label for="">Ruta de reportes</label>
                    <input type="text" class="form-control form-control-sm" formControlName="ReportsPath">
                </div>
            </form>

            <div class="row">
                <div class="col-sm-4 offset-sm-4">

                    <button type="button" class="form-control form-control-sm btn-light shadow-sm btn-st float-right" (click)="Store()"><i class="fa fa-floppy-o" aria-hidden="true"></i> Guardar</button>
                </div>
                <div class="col-sm-4">
                    <button type="button" class="form-control form-control-sm btn-light shadow-sm btn-st" (click)="DismissCompanyModal()"><i class="fa fa-times-circle" aria-hidden="true"></i> Cerrar&nbsp;</button>

                </div>
            </div>
        </div>
    </ng-template>
</block-ui>